"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { getPriorAuthorizationsByReferralId } from "@/src/requests/prior-authorization";
export const PRIOR_AUTHORIZATIONS_BY_REFERRAL_CACHE_KEY = "prior-authorizations-by-referral";
export function usePriorAuthorizationsByReferralId(referralId) {
  const $ = _c(11);
  let t0;
  let t1;
  if ($[0] !== referralId) {
    t0 = [PRIOR_AUTHORIZATIONS_BY_REFERRAL_CACHE_KEY, referralId];
    t1 = () => {
      if (!referralId) {
        return [];
      }
      return getPriorAuthorizationsByReferralId(referralId);
    };
    $[0] = referralId;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  const t2 = !!referralId;
  let t3;
  if ($[3] !== t0 || $[4] !== t1 || $[5] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2
    };
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const query = useQuery(t3);
  let t4;
  if ($[7] !== query.data) {
    t4 = query.data ?? [];
    $[7] = query.data;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = {
      priorAuthorizations: t4
    };
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}